// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"22":"b0069415","261":"a58512a7","516":"a72508f0","608":"26216337","631":"3a549015","722":"fb5fe598","825":"a1c4c679"}[chunkId] + ".css";
};